export default "__VITE_ASSET__BmTdiidV__"